import { CrewMember } from '@bechtel/types';

export interface UserInfoProps {
  crewMember: CrewMember;
  showBadgeNumber?: boolean;
}
